export default __webpack_public_path__ + "static/media/feature-project-mgt-1.52c7a8e0.png";